import React from 'react';
import { useInView, motion } from 'framer-motion';
import * as S from './styles';

const features = [
  {
    icon: '🚌',
    title: 'Gestão de Excursões',
    text: 'Crie e gerencie múltiplas excursões com controle de vagas, passageiros e status em tempo real — tudo em uma só tela.',
  },
  {
    icon: '📋',
    title: 'Documentação Simplificada',
    text: 'Organize RG, CPF, autorizações e qualquer documento necessário de forma segura e acessível de qualquer lugar.',
  },
  {
    icon: '🗓️',
    title: 'Planejamento de Eventos',
    text: 'Crie cronogramas detalhados e receba notificações automáticas quando os eventos se aproximarem. Zero surpresas.',
  },
  {
    icon: '💳',
    title: 'Controle Financeiro',
    text: 'Acompanhe pagamentos, parcelas e saldos em aberto. Saiba exatamente quanto foi arrecadado em tempo real.',
  },
  {
    icon: '🔔',
    title: 'Notificações Automáticas',
    text: 'Lembretes de pagamento e avisos de última hora enviados automaticamente. Você não precisa fazer nada.',
  },
  {
    icon: '📊',
    title: 'Relatórios Completos',
    text: 'Veja taxa de ocupação, histórico e desempenho de cada excursão para tomar decisões mais inteligentes.',
  },
];

export const FeaturesSection: React.FC = () => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.12 });

  return (
    <S.Section id="recursos" ref={ref}>
      <S.Header>
        <motion.div
          initial={{ opacity: 0, y: 26 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <S.SectionTag>Recursos</S.SectionTag>
        </motion.div>
        <S.SectionTitle
          as={motion.h2}
          initial={{ opacity: 0, y: 26 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          Tudo que você precisa,
          <br />
          em um único lugar
        </S.SectionTitle>
        <motion.p
          initial={{ opacity: 0, y: 26 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <S.SectionSub>
            Pare de usar 5 ferramentas diferentes. O Excursei resolve tudo.
          </S.SectionSub>
        </motion.p>
      </S.Header>
      <S.Grid>
        {features.map((feat, i) => (
          <motion.div
            key={feat.title}
            initial={{ opacity: 0, y: 26 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.1 + i * 0.09 }}
          >
            <S.Card>
              <S.FeatIcon>{feat.icon}</S.FeatIcon>
              <S.CardTitle>{feat.title}</S.CardTitle>
              <S.CardText>{feat.text}</S.CardText>
            </S.Card>
          </motion.div>
        ))}
      </S.Grid>
    </S.Section>
  );
};
